// frontend/src/services/deviceStore.js
// Capa de ALMACENAMIENTO de credenciales de dispositivo — DESACOPLADA (ajuste #4, T3).
// El resto del sistema usa SOLO get()/save()/clear(). La implementación física
// (hoy localStorage) puede cambiarse (sessionStorage, cookie, secure storage,
// backend) SIN rediseñar la arquitectura.
const KEY = 'kf25_device_credentials';

export function get() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;   // { deviceId, deviceSecret }
  } catch {
    return null;
  }
}

export function save(credentials) {
  localStorage.setItem(KEY, JSON.stringify(credentials));
}

export function clear() {
  localStorage.removeItem(KEY);
}
